import { useMantineColorScheme } from '@mantine/core';
import { BadgeCheck, CircleX } from 'lucide-react';

export const icons = {
  Failure: () => (
    <CircleX
      aria-label="Failure"
      role="img"
      stroke={
        useMantineColorScheme().colorScheme === 'dark'
          ? 'var(--color-red-700)'
          : 'var(--color-red-400)'
      }
    />
  ),
  Success: () => (
    <BadgeCheck
      aria-label="Success"
      role="img"
      stroke={
        useMantineColorScheme().colorScheme === 'dark'
          ? 'var(--color-lime-700)'
          : 'var(--color-lime-400)'
      }
    />
  ),
};
